import { Injectable, Inject } from '@angular/core';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

@Injectable({
    providedIn: 'root',
})
export class RailtracReportsService {
    controllername = 'Reports';
    constructor(
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
        @Inject('BASE_DEV_EXPRESS_URL') private devExpressBaseUrl: string,
    ) {}

    CreateAspNetDatastore(
        apiCall: string,
        reportName?: string,
        startDate?: string,
        endDate?: string,
        queryType?: string,
        extraParams?: { [key: string]: string },
    ): any {
        return AspNetData.createStore(<any>{
            key: '',
            loadUrl: `${this.devExpressBaseUrl}${this.controllername}/${apiCall}`,
            onLoaded: this.normalizeDateTimezones,
            onBeforeSend(method, ajaxOptions) {
                ajaxOptions.headers = {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Credentials': 'true',
                    'Access-Control-Allow-Methods': 'DELETE,GET,HEAD,OPTIONS,POST,PUT',
                    'Access-Control-Allow-Headers':
                        'Origin, X-Requested-With, Content-Type, Accept, Authorization',
                };
                if (reportName) {
                    ajaxOptions.data.reportName = reportName;
                }
                if (startDate) {
                    ajaxOptions.data.startDate = startDate;
                }
                if (endDate) {
                    ajaxOptions.data.endDate = endDate;
                }
                if (queryType) {
                    ajaxOptions.data.queryType = queryType;
                }
                if (extraParams) {
                    for (const key of Object.keys(extraParams)) {
                        const value = extraParams[key];
                        if (value !== null && value !== undefined) {
                            ajaxOptions.data[key] = value;
                        }
                    }
                }
            },
        });
    }

    private normalizeDateTimezones(items: any[]): void {
        if (!Array.isArray(items)) return;
        for (const item of items) {
            if (!item || typeof item !== 'object') continue;
            for (const key of Object.keys(item)) {
                const val = item[key];
                if (typeof val === 'string' && ISO_DATE_PATTERN.test(val)) {
                    item[key] = val.replace(/Z$/, '').replace(/[+-]\d{2}:\d{2}$/, '');
                }
            }
        }
    }
}
